export var MuiTextField = {
    defaultProps: { variant: 'outlined' },
};
